// import { useRecoilValue } from 'recoil';
import { useSendTransItem } from '../api';
import { useUpdateSessionCart } from '../useUpdateSessionCart';

// import { percomaticState } from '../../../atoms';

export const useAddCartItem = (onComplete?: () => void): (() => void) => {
	const updateSessionCart = useUpdateSessionCart(onComplete);
	const sendTransItem = useSendTransItem(updateSessionCart);

	return sendTransItem;
};
